import { useEffect, useState, startTransition, useMemo } from 'react';

/**
 * Progressive data loading hook for better INP scores.
 * Initially returns a subset of data for fast initial render,
 * then returns all data after mount.
 *
 * @param data - The full dataset
 * @param initialCount - Number of items to show initially
 * @returns Progressively loaded data
 */
export const useProgressiveData = <T>(data: T[], initialCount: number): T[] => {
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    startTransition(() => {
      setIsMounted(true);
    });
  }, []);

  return useMemo(
    () => (isMounted ? data : data.slice(0, initialCount)),
    [data, initialCount, isMounted],
  );
};
